<template>
    <rkm-area
        background-color="primary"
        closed
        header-prefix-text="O"
        title="Objetivo"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <strong>Informações relacionadas ao exame físico</strong><br><div v-html="formatDescricao(item.objetivo.descricao)"></div>
            </rkm-col>
        </rkm-row>

        <div v-show="item.isAtendimentoPuericultura">
            <rkm-row>
                <rkm-col cols="12">
                    <BoxPreNatalPartoNascimento
                        v-if="item.puericultura.isPrimeiroAtendimento"
                        :item="item"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="item.puericultura.isCriancaAleitamento && !item.puericultura.isPrimeiroAtendimento">
                <rkm-col cols="12">
                    <Item
                        :get-value="() => item.puericultura.aleitamentoTipo.descricao"
                        label="Tipo de aleitamento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxDesenvolvimentoCrianca :item="item" />
                </rkm-col>
            </rkm-row>
        </div>

        <template v-if="item.isAtendimentoPreNatal && !item.preNatal.isPrimeiroAtendimento">
            <rkm-row>
                <rkm-col cols="12">
                    <BoxPreNatal :item="item" />
                </rkm-col>
            </rkm-row>
        </template>

        <template v-else>
            <rkm-row v-if="item.sexoId === enums.sexo.FEMININO">
                <rkm-col cols="2">
                    <Item
                        :get-value="() => item.objetivo.dum"
                        label="DUM"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <rkm-row>
            <rkm-col cols="12">
                <BoxAntropometria :data="item.objetivo.antropometria" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxSinalVital :data="item.objetivo.sinalVital" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxGlicemiaCapilar :data="item.objetivo.glicemiaCapilar" />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.objetivo.marcadorConsumoAlimentar">
            <rkm-col cols="12">
                <BoxMarcadoresConsumoAlimentar :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.objetivo.tria">
            <rkm-col cols="12">
                <BoxTria :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.objetivo.vacinacaoEmDia === true
                        ? 'Sim' : (item.objetivo.vacinacaoEmDia === false ? 'Não' : 'Não informado')"
                    label="Vacinação em dia"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.objetivo.pacienteComNecessidadeEspecial === true
                        ? 'Sim' : (item.objetivo.pacienteComNecessidadeEspecial === false ? 'Não' : 'Não informado')"
                    label="Paciente com necessidades especiais"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Resultados de exames"
                    type="fieldset"
                    no-margin-top
                    class="pt-0"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxExameAvaliado :item="item" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxTriagemNeonatal :item="item" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxResultadoExame :item="item" />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxAntropometria from '@/components/ambulatorio/atendimento/components/historico/components/antropometria/Index'
import BoxDesenvolvimentoCrianca from './components/desenvolvimento-crianca/Index'
import BoxGlicemiaCapilar from '@/components/ambulatorio/atendimento/components/historico/components/glicemia-capilar/Index'
import BoxMarcadoresConsumoAlimentar from './components/marcador-consumo-alimentar/Index'
import BoxPreNatal from '@/components/ambulatorio/atendimento/components/historico/components/pre-natal/Index'
import BoxPreNatalPartoNascimento from '@/components/ambulatorio/atendimento/components/historico/components/pre-natal-parto-nascimento/Index'
import BoxResultadoExame from './components/resultado-exame/Index'
import BoxTria from './components/tria/Index'
import BoxExameAvaliado from './components/exame-avaliado/Index'
import BoxTriagemNeonatal from './components/triagem-neonatal/Index'
import BoxSinalVital from '@/components/ambulatorio/atendimento/components/historico/components/sinal-vital/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        BoxAntropometria,
        BoxDesenvolvimentoCrianca,
        BoxGlicemiaCapilar,
        BoxMarcadoresConsumoAlimentar,
        BoxPreNatal,
        BoxPreNatalPartoNascimento,
        BoxResultadoExame,
        BoxTria,
        BoxExameAvaliado,
        BoxTriagemNeonatal,
        BoxSinalVital,
        Item,
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        item: {type: Object, required: true},
    },
    methods: {
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
    }
}
</script>